// removed by extract-text-webpack-plugin
module.exports = {"Hero":"src-components-DayInTheLife-Hero----Hero-module---Hero---3JvQy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayInTheLife/Hero/Hero.module.scss
// module id = 719
// module chunks = 168000803916113